// @ts-expect-error Untyped import
import MessageEditor from './MessageEditor';
import throttle from 'hs-lodash/throttle';
import { memo, useCallback, useMemo, useRef } from 'react';
import { SEND_TYPING_MESSAGE_THROTTLE_MS } from '../../typing-indicators/constants/typingIndicatorConstants';
import { isPersistedThread } from '../../threads/operators/isPersistedThread';
import { MAX_FILE_SIZE } from '../../file-uploads/constants/fileUploadsConstants';
import { List } from 'immutable';
import { useFileUploadAnnouncements } from '../../file-uploads/hooks/useFileUploadAnnouncements';
// @ts-expect-error Untyped import
import { buildFileAttachment } from '../../file-uploads/operators/buildFileAttachment';
import getAllowedFileTypes from '../../file-uploads/util/getAllowedFileTypes';
// @ts-expect-error Untyped import
import { debouncedStagingEvent } from '../postInputStagingEvent';

// @ts-expect-error not typed
import { jsx as _jsx } from "react/jsx-runtime";
const MessageEditorWrapper = /*#__PURE__*/memo(props => {
  const {
    attachmentsError,
    canUploadAttachments,
    closeInitialMessageBubble,
    coloring,
    currentConversation,
    disablePublish,
    disableTextInput,
    enableAIDisclaimer,
    onSetMessageTextExternally,
    isIOSMobile,
    isOnFocus,
    isUngatedForCustomerAgentPrompts,
    isUngatedForScreenCapture,
    messagesPageUri,
    mobile,
    networkOffline,
    onRemoveAttachment,
    onSelectAttachmentFile,
    publishMessage,
    publishTypingMessage,
    removeMessageEditorStagingText,
    setMessageEditorStagingText,
    shouldDisableInitialInputFocus,
    shouldHideAttachmentButton,
    shouldSendInputStagingEvent,
    showInitialMessageBubble,
    showQuickReplyPlaceholder,
    showingHsBranding,
    spamProtectionEnabled,
    speechPocActive,
    speechRecordingStatus,
    stagedAttachments,
    stagedMessage,
    toggleOnAndOffInputFocus
  } = props;
  useFileUploadAnnouncements(stagedAttachments || List(), attachmentsError);
  const publishTypingMessageThrottled = useMemo(() => throttle(publishTypingMessage, SEND_TYPING_MESSAGE_THROTTLE_MS, {
    leading: true,
    trailing: false
  }), [publishTypingMessage]);
  const inputStagingEvent = useRef(debouncedStagingEvent).current;
  const onChatInputChanged = useCallback(messageText => {
    setMessageEditorStagingText(messageText);
    if (!disablePublish && messageText !== '') {
      publishTypingMessageThrottled({
        thread: currentConversation
      });
    }
    if (shouldSendInputStagingEvent) {
      inputStagingEvent(messageText, false);
    }
    if (showInitialMessageBubble) {
      closeInitialMessageBubble();
    }
  }, [setMessageEditorStagingText, disablePublish, publishTypingMessageThrottled, currentConversation, shouldSendInputStagingEvent, inputStagingEvent, showInitialMessageBubble, closeInitialMessageBubble]);
  const onPublishMessage = useCallback(({
    text,
    richText,
    quickReply
  }) => {
    publishTypingMessageThrottled.cancel();
    publishMessage({
      text,
      richText,
      quickReply,
      url: messagesPageUri,
      fileAttachment: buildFileAttachment(stagedAttachments)
    });
    removeMessageEditorStagingText();
  }, [publishTypingMessageThrottled, publishMessage, messagesPageUri, stagedAttachments, removeMessageEditorStagingText]);
  const onSelectAttachmentFiles = useCallback(({
    files
  }) => {
    if (!files || !files.length) {
      return;
    }
    const file = files.item(0);
    if (file) {
      onSelectAttachmentFile({
        file,
        thread: currentConversation,
        source: 'file_upload'
      });
    }
  }, [onSelectAttachmentFile, currentConversation]);
  const onRemoveAttachmentHandler = useCallback(({
    attachment
  }) => {
    onRemoveAttachment({
      attachment,
      thread: currentConversation
    });
  }, [onRemoveAttachment, currentConversation]);
  return /*#__PURE__*/_jsx(MessageEditor, {
    coloring: coloring,
    chatInputChanged: onChatInputChanged,
    disabled: disableTextInput,
    disablePublish: disablePublish,
    onSetMessageTextExternally: onSetMessageTextExternally,
    isOnFocus: isOnFocus,
    maxAttachmentFileSize: MAX_FILE_SIZE,
    mobile: mobile,
    isIOSMobile: isIOSMobile,
    networkOffline: networkOffline,
    onSelectAttachmentFiles: onSelectAttachmentFiles,
    onRemoveAttachment: onRemoveAttachmentHandler,
    publishMessage: onPublishMessage,
    shouldHideAttachmentButton: shouldHideAttachmentButton,
    shouldDisableInitialInputFocus: shouldDisableInitialInputFocus,
    enableAIDisclaimer: enableAIDisclaimer,
    showingHsBranding: showingHsBranding,
    spamProtectionEnabled: spamProtectionEnabled,
    speechPocActive: speechPocActive,
    speechRecordingStatus: speechRecordingStatus,
    stagedAttachments: stagedAttachments,
    stagedMessageEditorText: stagedMessage,
    supportsAttachments: isPersistedThread(currentConversation),
    toggleOnAndOffInputFocus: toggleOnAndOffInputFocus,
    fileTypes: getAllowedFileTypes(),
    showQuickReplyPlaceholder: showQuickReplyPlaceholder,
    shouldSendInputStagingEvent: shouldSendInputStagingEvent,
    inputStaging: inputStagingEvent,
    canUploadAttachments: canUploadAttachments,
    isUngatedForScreenCapture: isUngatedForScreenCapture,
    isUngatedForCustomerAgentPrompts: isUngatedForCustomerAgentPrompts
  });
});
MessageEditorWrapper.displayName = 'MessageEditorWrapper';
export default MessageEditorWrapper;